import React from 'react'

import PaykaLogo from '../../assets/icons/payka-logo.svg'
import PaykaLoaderIcon from './PaykaLoaderIcon/PaykaLoaderIcon'
import { PageLoaderProps } from './PageLoaderProps'

import './PageLoaderStyles.scss'


const PageLoader = (props: PageLoaderProps) => {

   const { waitingText } = props

   return (
      <div className='page-loader-outer-wrapper'>
         <img src={PaykaLogo} alt='logo' />
         <PaykaLoaderIcon />
         <p className='page-loader-waiting-text'>{waitingText}</p>
      </div>
   )
}

export default PageLoader
